import Button from 'components/Button';
import { useContext, useMemo } from 'react';
import SessionContext from '../../../contexts/session';
import env from '../../../config/env';
import { QRCodeCanvas } from 'qrcode.react';
import { NavLink } from 'react-router-dom';

const HomePage = () => {
  const { user, token } = useContext(SessionContext);
  const loginUrl = useMemo(() => {
    return `${env.API_ROOT_PATH?.replace(
      '/api',
      '/login-store'
    )}?token=${token}`;
  }, [token]);

  return (
    <div className="page-initial d-flex">
      <div className="text-wrap text-end d-flex flex-column justify-content-center flex-fill lh-1 page-inital-text">
        <p className="font-size-1 fw-light text-white page-initial-text-margin-1">
          Faça já a sua
        </p>
        <p className="font-size-2 fw-bold text-white page-initial-text-margin-2">
          Recarga
        </p>
        <p className="font-size-2 fw-bold text-white page-initial-text-margin-2">
          de celular
        </p>
        <p className="font-size-1 fw-light text-white page-initial-text-margin-1">
          com
        </p>
        <p className="font-size-2 fw-bold text-white page-initial-text-margin-1">
          PIX
        </p>
        <div>
          {user && (
            <Button
              className="btn btn-white text-decoration-none text-primary px-5 btn-lg rounded-5 py-3"
              tag={NavLink}
              to="/number"
            >
              COMEÇAR
            </Button>
          )}
          {!user && (
            <div className="d-flex justify-content-center align-items-end flex-column">
              <p className="text-light">
                Faça o login para começar{' '}
                <small>
                  <br /> Aponte o celular para o QR Code
                </small>
              </p>

              <div className="p-3 bg-white rounded-2">
                <QRCodeCanvas value={loginUrl} />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default HomePage;
